module.exports = __webpack_public_path__ + "static/media/Taxation.f16761a3.xlsx";